import React, { Component } from 'react'
import styled from 'styled-components'
import { Document as Pdf, Page } from 'react-pdf'
import { media } from 'styled-bootstrap-grid'


export default class DocumentExtended extends Component {
  state = {

  }

  returnString(needle, haystack) {
    if (haystack) {
      return haystack.find(straw => straw.slug === needle).title
    } else {
      return needle
    }
  }

    //Decodes HTML entities so &#8211 becomes "-" etc.
    toPlainText = (html) => {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }

  render() {
    const { url, id, title, pageNumber } = this.props
    return (
      <Wrapper>
        <DocumentWrapper>
          <Document key={id}>
            <FlexWrapper>
              <Meta>
              <Type>{this.toPlainText(title)}</Type>
                {this.props.label &&
                  <Language></Language>
                }
              </Meta>

            </FlexWrapper>
            <FlexWrapperPdf
              href={url}
              target="_blank"
            >
              <PdfExtended
                file={url}
                onLoadSuccess={this.onDocumentLoadSuccess}
              >
                <Page
                  pageNumber={pageNumber}
                  scale={0.35}
                  renderAnnotations={false}
                />
              </PdfExtended>
            </FlexWrapperPdf>
            <Download href={url} download>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="17"
                viewBox="0 0 10 12"
              >
                <g fill="#ffffff" fillRule="evenodd">
                  <path d="M1.179 3.644a.6.6 0 01.848 0L4.184 5.8V.6a.6.6 0 011.2 0v5.2l2.157-2.156a.6.6 0 01.848.848L5.21 7.673a.6.6 0 01-.85 0l-3.18-3.18a.6.6 0 010-.85M8.968 10.648H.6a.6.6 0 010-1.2h8.368a.6.6 0 010 1.2"></path>
                </g>
              </svg>
            </Download>
          </Document>
        </DocumentWrapper>
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.section`
height: 100%;
`

const FlexWrapper = styled.div`
margin-right: 10px;
width: 100%;
`
const FlexWrapperPdf = styled.a`
margin-right: 10px;
`

const PdfExtended = styled(Pdf)`
canvas {
  margin: auto;
}
`


const DocumentWrapper = styled.div`
display flex;
width: 100%;
flex-wrap: wrap;
justify-content: space-around;
row-gap: 20px;
height: 100%;
`

const Document = styled.div`
  padding: 18px;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;



  ${media.md`
 
  padding: 10px;
  `}
  ${media.lg`
  
  `}
  ${media.xl`
  
  `}
  
`

const Meta = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const Product = styled.span`
  font-size: 10px;
`

const Language = styled.span`
  font-size: 10px;
  color: #646464;
  padding: 0.5em 1.5em;
  border: 1px solid #646464;
  border-radius: 2em;
  margin-left: 3%;
  opacity: 0.5;
`

const Type = styled.h2`
  font-size: 0.6em !important;
  font-weight: 300;
  margin-bottom: 0px !important;

 
`

const Download = styled.a`
  font-size: 10px;
  background: ${props => props.theme.colors.primary};
  color: white;
  padding: 0.5em 1.5em;
  border-radius: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 400ms;
  height: max-content;
  align-self: flex-end;

  ${media.sm`
  width: 100%;
  `}

  ${media.md`
  width: 100%;
  `}


  ${media.lg`
    
  `}

  &:hover {
    background: ${props => props.theme.colors.secondary};
  }
`



// WEBPACK FOOTER //
// ./src/ui/components/Navigation/Search/documentExtended.js